export class Credentials {

    public email: string = "";
    public password: string = "";
    
    constructor() {}
}
